import base58 from '../utils/base58';
import { LockupScriptCodec } from '../utils/parser';

const AddressType = {
     P2PKH: 0x00,
     P2MPKH: 0x01,
     P2SH: 0x02,
     P2C: 0x03
};

export default {
     /**
     * https://github.com/alephium/alephium-web3/blob/master/packages/web3/src/address/address.ts
     * 
     * @param {string} address 
     * @returns 
     */
     isValidAddress(address) {
          try {
               const decoded = base58.decode(address);

               const addressType = decoded[0]
               if (addressType === AddressType.P2MPKH) {
                    return new LockupScriptCodec().validate(decoded);
               } else if (addressType === AddressType.P2PKH
                    || addressType === AddressType.P2SH
                    || addressType === AddressType.P2C) {
                    return decoded.length === 33;
               }
               return false;
          } catch (error) {
               return false;
          }
     },
};